/**
 * Etiqueta de metodología de una plantilla (OT-0055): el nombre de la
 * metodología a la que pertenece, o "Base" / "Genérica" si no pertenece a
 * ninguna. La usan las tarjetas del catálogo.
 */

import type { Methodology } from '../api/methodologies'
import type { Template } from '../api/templates'

export function templateMethodologyLabel(
  template: Pick<Template, 'methodology_id' | 'is_system_default'>,
  byId: ReadonlyMap<string, Methodology>,
  t: (key: 'catalog.card.generic_product' | 'catalog.card.generic_tenant') => string,
): string {
  if (template.methodology_id === null) {
    return t(
      template.is_system_default
        ? 'catalog.card.generic_product'
        : 'catalog.card.generic_tenant',
    )
  }
  // Sin etiqueta mientras la lista de metodologías no ha llegado.
  return byId.get(template.methodology_id)?.name ?? ''
}
